import type {
  AssessmentResultParentWithObligationResultsResponseRow,
  ObligationRegisterResponseRow,
} from '@risksmart-app/drizzle/src/types';
import type { ObligationRegisterResponse } from '@risksmart-app/trpc/src/types';
import type { GetObligationsQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetObligationsDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

const mapTrpcAssessmentResultParentToGraphQL = (
  assessment_result_parent: AssessmentResultParentWithObligationResultsResponseRow
): GetObligationsQuery['assessment_result_parent'][number] => ({
  ...assessment_result_parent,
});

const mapTrpcObligationToGraphQL = (
  obligation: ObligationRegisterResponseRow
): GetObligationsQuery['obligation'][number] => ({
  ...obligation,
  Parent: obligation.parent,
  BreachedIssues: obligation.issues,
  CreatedByUser: obligation.CreatedByUser,
  ModifiedByUser: obligation.ModifiedByUser,
  CreatedBy: obligation.createdBy,
  ModifiedBy: obligation.modifiedBy,
  controls_aggregate: {
    aggregate: {
      count: obligation.controls.length,
    },
  },
});

export const mapTrpcObligationsToGraphQL = (
  trpcData: ObligationRegisterResponse | undefined
): GetObligationsQuery | undefined => {
  if (!trpcData) {
    return undefined;
  }

  return {
    obligation: trpcData.obligation.map(mapTrpcObligationToGraphQL),
    assessment_result_parent: trpcData.assessment_result_parent.map(
      mapTrpcAssessmentResultParentToGraphQL
    ),
  };
};

type UseGetObligationsRegisterArgs = Record<string, never>;

export const useGetObligationsRegister = createQueryHook<
  UseGetObligationsRegisterArgs,
  ObligationRegisterResponse,
  GetObligationsQuery
>({
  trpcQueryOptions: (trpc) => trpc.frontend.obligation.register.queryOptions(),
  mapTrpcDataToGraphQL: (data) => ({
    obligation: data.obligation.map(mapTrpcObligationToGraphQL),
    assessment_result_parent: data.assessment_result_parent.map(
      mapTrpcAssessmentResultParentToGraphQL
    ),
  }),
  graphqlDocument: GetObligationsDocument,
  graphqlVariables: () => ({
    includeAssessmentResultsHistory: true,
  }),
});
